import React from 'react';
import { Box } from '@mui/material';
import OwwLogo from '../Assets/owwtransparentlogo.png';

const LogoSection = () => {
    return (
        <Box
            sx={{
                textAlign: 'center',
                mb: { xs: 0, sm: 2 },
                display: { xs: 'block', sm: 'block', md: 'none' } // Hide on desktop, visible on tab and mobile
            }}
        >
            <img
                src={OwwLogo}
                alt="Oman Water Week"
                style={{
                    width: '70%',
                    height: { xs: '160px', sm: '180px' },
                    maxWidth: { xs: '260px', sm: '280px' },
                    marginTop: { xs: '32px', sm: '20px' },
                    marginBottom: { xs: '32px', sm: '20px' },
                    objectFit: 'contain'
                }}
            />
        </Box>
    );
};

export default LogoSection;